import { render, staticRenderFns } from "./AvatarBuilderControl.vue?vue&type=template&id=2520422f&scoped=true&"
import script from "./AvatarBuilderControl.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderControl.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderControl.vue?vue&type=style&index=0&id=2520422f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520422f",
  null
  
)

export default component.exports